import React, { useEffect } from "react";
import BannerSlider from "../components/BannerSlider.jsx";
import Commit from "../components/Commit.jsx";
import FlowerCatalog from "../components/FlowerCatalog.jsx";
import HotProduct from "../components/HotProduct.jsx";
import BlogFlower from "../components/BlogFlower.jsx";
import StoreList from "../components/StoreList.jsx";
import ImageSlider from "../components/ImageSlider.jsx";

const MainPage = () => {
  useEffect(() => {
    document.title = "Thanh Flower - Hoa Tươi Cần Thơ";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <BannerSlider />
      <Commit />
      <FlowerCatalog />
      <HotProduct />
      <BlogFlower />
      {/* <StoreList /> */}
      <ImageSlider />
    </div>
  );
};

export default MainPage;
